<template>
  <div>
    <custom-table
      ref="customTable"
      custom-class="table-h-36"
      :columns="columns"
      :custom-view="customView"
      :is-page-show="false"
      :hidden-filters="{ id_branch: idBranch }"
      :count-keys="countKeys"
      api-url="/asset/v1/get-prepair-wait-list"
      download-file-name="danh-sach-hoa-don.xlsx"
      table-height="calc(100vh - 230px)"
    ></custom-table>
  </div>
</template>

<script>
import { CUSTOM_VIEW } from "@/libs/const";

export default {
  name: "WaitList",
  props: {
    idBranch: {
      type: [String, Number],
      default: () => null,
    },
  },
  data: () => ({
    columns: [],
    countKeys: [],
    customView: CUSTOM_VIEW.ASSET_PREPAIR_WAIT_LIST,
  }),
  created() {
    const columns = [
      {
        type: "",
        label: this.$t("Cơ sở"),
        placeholder: this.$t("Cơ sở"),
        name: "id_branch",
        hasSort: false,
        sortName: "id_branch",
        key: "branch_code",
        required: true,
      },
      {
        type: "",
        label: this.$t("Mã"),
        placeholder: this.$t("Mã"),
        name: "name",
        hasSort: false,
        sortName: "name",
        key: "name",
        required: true,
      },
      {
        type: "",
        label: this.$t("Loại tài sản"),
        placeholder: this.$t("Loại tài sản"),
        name: "id_asset_type",
        hasSort: true,
        sortName: "id_asset_type",
        key: "asset_type_name",
        required: true,
        options: [],
      },
      {
        type: "",
        label: this.$t("TG. Chờ"),
        placeholder: this.$t("TG. Chờ"),
        name: "wait_prepair_at",
        hasSort: false,
        sortName: "wait_prepair_at",
        key: "wait_prepair_at",
        component: "CountUp",
        required: true,
      },
    ];
    this.columns = [...columns];

    const countKeys = [
      {
        text: "Xe",
        key: "count_bike",
      },
      {
        text: "Chìa khóa",
        key: "count_key",
      },
      {
        text: "Mũ bảo hiểm",
        key: "count_helmet",
      },
      {
        text: "Sạc",
        key: "count_charger",
      },
    ];
    this.countKeys = [...countKeys];
  },
  methods: {},
};
</script>
